module.exports = __webpack_public_path__ + "img/tile-rendering-desktop_cn.77d9229.jpg";